module.exports = __webpack_public_path__ + "media/images/icon/white/ico_tel-f5d8f4ab4f099df9c04a5a636462dc39.svg";